// Resolves the API base URL for fetch calls.
// On production (moodofthe.world), uses relative paths to avoid cross-origin
// redirect issues (bare domain → www redirect breaks CORS).
// In dev/preview, uses the REACT_APP_BACKEND_URL env variable.
const envUrl = process.env.REACT_APP_BACKEND_URL || '';

const isProd = typeof window !== 'undefined' &&
  window.location.hostname.includes('moodofthe.world');

export const API_BASE = isProd ? '' : envUrl;
export const API = `${API_BASE}/api`;
